import { useMutation } from "@tanstack/react-query";
import { useRouter } from "next/router";

import { accessTokenAtom, refreshTokenAtom } from "@/atoms/authAtoms";
import type { User } from "@/atoms/userAtom";
import userAtom from "@/atoms/userAtom";
import type { SignInReqParams } from "@/schemas/auth";
import axios from "@/services/axios.config";
import { authStore } from "@/stores/auth.store";
import { toastOnError } from "@/utils/toastOnError";

type ResponseData = {
	accessToken: string;
	refreshToken: string;
} & User;

const signIn = (data: SignInReqParams) =>
	axios
		.post<APIResponse<ResponseData>>("/auth/signin", data)
		.then((res) => res.data.data as ResponseData)
		.catch((err) => Promise.reject(err.response.data as APIResponse));

export default function useSignIn() {
	const router = useRouter();
	return useMutation<ResponseData, APIResponse, SignInReqParams>(signIn, {
		retry: 0,
		onSuccess: (data) => {
			authStore.set(accessTokenAtom, data.accessToken);
			authStore.set(refreshTokenAtom, data.refreshToken);
			authStore.set(userAtom, data);
		},
		onError: (err) => {
			if (err.msg === "Email Not Verified") {
				router.push("/email/verification-info");
			} else toastOnError(err, err.msg);
		},
	});
}
